import { useTranslation } from "react-i18next";

import { FilterOutlined } from "@ant-design/icons";
import { Calendar, ConfigProvider, DatePicker, Row, Select, Space, Button, Card, Flex, Breadcrumb, Checkbox } from "antd";
import { CardContainer } from "components/elements";
import MyTeamWorkScheduleTable from "components/table/MyTeamWorkScheduleTable";
import enUS from "antd/es/locale/en_US";
import thTh from "antd/es/locale/th_TH";
import dayjs from "dayjs";
import { useState } from "react";
import WorkscheduleFilter from "./WorkscheduleFilter";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import { useSelector } from "react-redux";

function MyTeamWorkSchedule({
  isLoading = false,
  selectedDate = null,
  workScheduleList = [],
  onFilter = () => { },
  onDateChange = () => { },
  onAssignShift = () => { },
  ModalEditAll = () => { },
  setOpenAll = () => { },
  modifiedDepartmentOptions = [],
  modifiedPositionOptions = [],
  employeeTypeOptions = [],
  modifiedAttendanceSettingShift = [],
  Drower = () => { },
  ModalEdit = () => { },
  onSearch = () => { },
  columns = [],
  assignShift = {},
  setSearchName = () => { },
  setSearchNo = () => { },
  setSearchDepartment = () => { },
  setSearchPosition = () => { },
  onPageChange = () => { },
  pagination = {},
  isShiftHrView = false,
  handleHrViewChange = () => { },
}) {
  const { t, i18n } = useTranslation();
  const [useFilter, setUseFilter] = useState(false);
  const { roles } = useSelector((state) => state.company);

  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      <Flex vertical>
        <Breadcrumb items={[
          { title: t("home.header"), href: "/" },
          { title: t("my_team.header"), href: "" },
          { title: t("work_schedule.header") },
        ]} />
        <h2>{t("work_schedule.header")}</h2>
      </Flex>

      {<Drower />}
      {<ModalEdit />}
      <Row justify="space-between">
        <Space size={12}>
          <ConfigProvider locale={i18n.language == 'en' ? enUS : thTh}>
            <DatePicker defaultValue={dayjs()} onChange={onDateChange} picker="month" format="MMM YYYY" size="large" />
          </ConfigProvider>

          {roles.includes("ROLE_HR") ?
            <Flex gap={8} align="center">
              <Checkbox
                checked={isShiftHrView}
                onChange={handleHrViewChange}
              />
              <span>{t("calendar.label.hr_view")}</span>
            </Flex>
            : null}
        </Space>
        <Space size={12}>
          <Button type="default" onClick={() => setUseFilter(!useFilter)} style={{ padding: "8px 16px", height: "40px", borderRadius: "8px" }}>
            <Flex align="center" justify="center" gap={8}>
              <FilterIcon />
              <span style={{ color: "#667085" }}>{t('common.filter')}</span>
            </Flex>
          </Button>
          <Button onClick={() => { setOpenAll(true) }} type="primary" style={{ backgroundColor: "var(--button-color)", color: "var(--button-text-color)", height: "40px", borderRadius: "8px" }}> จัดกะการทำงานแบบกลุ่ม</Button>
          <Button onClick={onAssignShift} type="primary" style={{ backgroundColor: "var(--button-color)", color: "var(--button-text-color)", height: "40px", borderRadius: "8px" }}> {assignShift.active ? t("team.label.cancel_assign_shift") : t("team.label.assign_shift")}</Button>
        </Space>
      </Row >
      {(useFilter) && (
        <Card style={{ border: "solid 1px #EAECF0" }}>
          <WorkscheduleFilter
            departmentOptions={modifiedDepartmentOptions}
            positionOptions={modifiedPositionOptions}
            employeeTypeOptions={employeeTypeOptions}
            attendanceSettingShift={modifiedAttendanceSettingShift}
            setSearchName={setSearchName}
            setSearchNo={setSearchNo}
            setSearchDepartment={setSearchDepartment}
            setSearchPosition={setSearchPosition}
            // dataFlag={pendingTab}
            // leaveGroupOptions={modifiedLeaveGroupOptions}
            // companyRegulationOptions={modifiedCompanyRegulationOptions}
            // employeeOptions={modifiedEmployeeOptions}
            // penaltiesOptions={modifiedPenaltiesOptions}
            // offsiteOptions={modifiedOffSiteOptions}
            onSubmit={onSearch}
          />
        </Card>
      )
      }
      {ModalEditAll()}
      <MyTeamWorkScheduleTable
        columns={columns}
        isLoading={isLoading}
        dataSource={workScheduleList}
        onPageChange={onPageChange}
        pagination={pagination}

      />
    </Space >
  );
}

export default MyTeamWorkSchedule;
